"use strict";
/**
 * Supplier grid push contracts (GH547 Task 14) — `/api/supplier-linking/qvet-push/*`.
 *
 * Takes our links to QVET's article supplier grid: the supplier reference (our link SKU), the
 * list price without VAT (QVET keeps the list price; discounts go on the invoice) and the
 * habitual supplier (decision D3). The preview is read-only; staging only writes the change
 * into the article's pending rows, and the existing «Escribir en QVET» push sends it.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUPPLIER_GRID_BLOCK_REASON_LABELS = exports.SupplierGridBlockReason = exports.SUPPLIER_GRID_CHANGE_KIND_LABELS = exports.SupplierGridChangeKind = void 0;
/** What a single grid change does. */
var SupplierGridChangeKind;
(function (SupplierGridChangeKind) {
    /** The supplier has no row in QVET's grid yet: a `Created` row */
    SupplierGridChangeKind["add_row"] = "add_row";
    SupplierGridChangeKind["change_reference"] = "change_reference";
    SupplierGridChangeKind["change_list_price"] = "change_list_price";
    SupplierGridChangeKind["change_preferred"] = "change_preferred";
})(SupplierGridChangeKind || (exports.SupplierGridChangeKind = SupplierGridChangeKind = {}));
exports.SUPPLIER_GRID_CHANGE_KIND_LABELS = {
    [SupplierGridChangeKind.add_row]: "Añadir proveedor",
    [SupplierGridChangeKind.change_reference]: "Cambiar referencia",
    [SupplierGridChangeKind.change_list_price]: "Cambiar precio de lista",
    [SupplierGridChangeKind.change_preferred]: "Cambiar habitual",
};
/** Why a change the links ask for is NOT staged. */
var SupplierGridBlockReason;
(function (SupplierGridBlockReason) {
    /** Another article already has this reference for this supplier: QVET answers 500 «ya asignada» */
    SupplierGridBlockReason["reference_in_use"] = "reference_in_use";
    /** List price differs from QVET's by more than ×0.6–×1.6: usually a piece against a pack */
    SupplierGridBlockReason["price_out_of_range"] = "price_out_of_range";
    /** The link's product is not in the supplier's list (no price to send) */
    SupplierGridBlockReason["no_list_price"] = "no_list_price";
})(SupplierGridBlockReason || (exports.SupplierGridBlockReason = SupplierGridBlockReason = {}));
exports.SUPPLIER_GRID_BLOCK_REASON_LABELS = {
    [SupplierGridBlockReason.reference_in_use]: "La referencia ya la tiene otro artículo en QVET",
    [SupplierGridBlockReason.price_out_of_range]: "El precio de lista se aleja mucho del de QVET; revisar (¿pieza contra paquete?)",
    [SupplierGridBlockReason.no_list_price]: "El código no está en la lista del proveedor",
};
